import { Navigate, Outlet } from "react-router-dom";
import jsonFromDocument from "cerulean/src/JsonFromDocument";

export function AuthenticatedRoute() {
  const currentUser = jsonFromDocument("current_user", "null");

  // If user is not authenticated, redirect to login
  if (!currentUser) {
    const currentPath = window.location.pathname + window.location.search;
    return <Navigate to={`/login?next=${encodeURIComponent(currentPath)}`} replace />;
  }

  return <Outlet />;
}

export function UnauthenticatedRoute() {
  const currentUser = jsonFromDocument("current_user", "null");

  // If user is authenticated, redirect to dashboard (or "next" param if present)
  if (currentUser) {
    const urlParams = new URLSearchParams(window.location.search);
    const next = urlParams.get("next") || "/";
    return <Navigate to={next} replace />;
  }

  return <Outlet />;
}
